import Billboard from './Billboard';
export default Billboard;
